import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { FARMA, investment } from '../farmaferContent';

const formatMoney = (n) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: investment.currency,
    maximumFractionDigits: 0,
  }).format(n);

const Investment = () => (
  <Box
    component="section"
    id="inversion"
    py={{ xs: 7, md: 10 }}
    px={{ xs: 2.5, sm: 4, md: 7 }}
    sx={{
      background: `
        radial-gradient(ellipse 80% 60% at 10% 0%, rgba(26,143,100,0.18) 0%, transparent 50%),
        linear-gradient(165deg, ${FARMA.greenDeep} 0%, ${FARMA.green} 55%, #0D8058 100%)
      `,
      color: FARMA.white,
    }}
  >
    <Box maxWidth={720} mx="auto">
      <Typography
        sx={{
          fontFamily: '"Outfit", "Source Sans 3", sans-serif',
          fontWeight: 700,
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
          fontSize: '0.75rem',
          color: 'rgba(255,255,255,0.72)',
          mb: 1.25,
        }}
      >
        {investment.overline}
      </Typography>
      <Typography
        component="h2"
        sx={{
          fontFamily: '"Outfit", "Source Sans 3", sans-serif',
          fontWeight: 800,
          letterSpacing: '-0.03em',
          fontSize: { xs: '1.85rem', md: '2.55rem' },
          mb: 1.25,
        }}
      >
        {investment.title}
      </Typography>
      <Typography
        sx={{
          fontFamily: '"Source Sans 3", "Outfit", sans-serif',
          color: 'rgba(255,255,255,0.82)',
          fontSize: { xs: '1.05rem', md: '1.12rem' },
          lineHeight: 1.65,
          mb: 4,
          maxWidth: 520,
        }}
      >
        {investment.subtitle}
      </Typography>

      <Box
        component="ul"
        sx={{ listStyle: 'none', m: 0, p: 0, mb: 3 }}
      >
        {investment.lines.map((line) => (
          <Box
            component="li"
            key={line.id}
            display="flex"
            justifyContent="space-between"
            alignItems="baseline"
            py={2}
            borderBottom="1px solid rgba(255,255,255,0.18)"
            sx={{ gap: 2 }}
          >
            <Typography
              sx={{
                fontFamily: '"Source Sans 3", "Outfit", sans-serif',
                fontSize: { xs: '1.05rem', md: '1.15rem' },
                fontWeight: 500,
              }}
            >
              {line.label}
            </Typography>
            <Typography
              sx={{
                fontFamily: '"Outfit", "Source Sans 3", sans-serif',
                fontWeight: 800,
                fontSize: { xs: '1.15rem', md: '1.3rem' },
                whiteSpace: 'nowrap',
              }}
            >
              {formatMoney(line.amount)}
            </Typography>
          </Box>
        ))}
      </Box>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-end"
        flexWrap="wrap"
        sx={{ gap: 2 }}
        pt={1}
      >
        <Box>
          <Typography
            sx={{
              fontFamily: '"Outfit", "Source Sans 3", sans-serif',
              fontWeight: 700,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              fontSize: '0.72rem',
              color: 'rgba(255,255,255,0.7)',
              mb: 0.5,
            }}
          >
            Total a cancelar
          </Typography>
          <Typography
            sx={{
              fontFamily: '"Source Sans 3", "Outfit", sans-serif',
              color: 'rgba(255,255,255,0.78)',
              maxWidth: 320,
              lineHeight: 1.5,
            }}
          >
            {investment.note}
          </Typography>
        </Box>
        <Typography
          sx={{
            fontFamily: '"Outfit", "Source Sans 3", sans-serif',
            fontWeight: 800,
            letterSpacing: '-0.04em',
            fontSize: { xs: '3.2rem', md: '4.25rem' },
            lineHeight: 1,
            animation: 'farmaTotalIn 1s ease both',
            '@keyframes farmaTotalIn': {
              from: { opacity: 0, transform: 'scale(0.94)' },
              to: { opacity: 1, transform: 'scale(1)' },
            },
          }}
        >
          {formatMoney(investment.total)}
        </Typography>
      </Box>
    </Box>
  </Box>
);

export default Investment;
